import {
  gen7Backend,
  gen7CoreTeam,
  gen7CoreTeamThumb,
  gen7Event,
  gen7Frontend,
  gen7Lead,
  gen7LeadThumb,
  gen7Marketing,
  gen7Nontech,
  gen7NontechThumb,
  gen7Technical,
  gen7TechnicalThumb,
} from "assets/images";

export interface HistoryMember {
  id: string;
  name: string;
  role: string;
  department: string;
  avatar?: string;
  photos?: string[]; // Photos showcase
  accentColor?: string; // google.blue | google.red | google.yellow | google.green
  bio?: string;
  description?: string[]; // Descriptions corresponding to each photo in photos[]
  descriptions?: string[]; // Plural alias for description[]
  subRoles?: string[]; // Sub-team name or role corresponding to each photo in photos[]
  socials?: {
    facebook?: string;
    linkedin?: string;
    github?: string;
    email?: string;
  };
}

export interface HistoryTerm {
  id: string; // e.g. "gen-7"
  slug: string;
  title: string;
  subTitle: string;
  academicYear: string;
  slogan: string;
  description: string;
  coverImage: string;
  colorScheme: string; // google.blue | google.red | google.yellow | google.green
  stats?: {
    membersCount: number;
    eventsCount: number;
    highlights?: string;
  };
  members: HistoryMember[];
}

export const HISTORY_TERMS: HistoryTerm[] = [
  {
    id: "gen-7",
    slug: "gen-7",
    title: "GENERATION 7",
    subTitle: "Nhiệm kì 2025 - 2026",
    academicYear: "2025 - 2026",
    slogan: "Code the Future, Empower the Youth",
    description:
      "Tập trung thúc đẩy năng lực lập trình sinh viên thông qua các cuộc thi công nghệ và dự án thực chiến.",
    coverImage: gen7CoreTeam,
    colorScheme: "google.blue",
    stats: {
      membersCount: 20,
      eventsCount: 1,
      highlights: "AI Riser 2026 với quy mô 100+ người tham gia",
    },
    members: [
      {
        id: "gen7-core-team",
        name: "Core Team",
        role: "Ban Quản Trị & Điều Hành",
        department: "Core Team",
        avatar: gen7CoreTeamThumb,
        photos: [gen7CoreTeam],
        subRoles: ["Core Team Gen 7"],
        description: [
          "Đội ngũ nòng cốt hoạch định kế hoạch hành động, quản trị nhân sự và điều phối hoạt động nhịp nhàng giữa các ban chuyên môn.",
        ],
        bio: "Đội ngũ nòng cốt hoạch định kế hoạch hành động, quản trị nhân sự và điều phối hoạt động nhịp nhàng giữa các ban chuyên môn.",
        accentColor: "google.blue",
      },
      {
        id: "gen7-lead",
        name: "Team Leader",
        role: "Club Lead & Co-Lead",
        department: "Core Team",
        avatar: gen7LeadThumb,
        photos: [gen7Lead],
        subRoles: ["Ban Điều Hành (Leads)"],
        description: [
          "Định hướng chiến lược, kết nối mạng lưới Google Developer Groups và dẫn dắt cộng đồng sinh viên công nghệ DUT phát triển vững mạnh.",
        ],
        bio: "Định hướng chiến lược, kết nối mạng lưới Google Developer Groups và dẫn dắt cộng đồng sinh viên công nghệ DUT phát triển vững mạnh.",
        accentColor: "google.red",
      },
      {
        id: "gen7-nontech",
        name: "Non-technical",
        role: "Non-Technical Department",
        department: "Non-Technical",
        avatar: gen7NontechThumb,
        photos: [gen7Nontech, gen7Event, gen7Marketing],
        subRoles: [
          "Ban Non-Tech (Vận Hành)",
          "Ban Sự Kiện (Events)",
          "Ban Truyền Thông & Marketing",
        ],
        description: [
          "Quản trị nhân sự nội bộ, kết nối đối ngoại, bảo đảm hậu cần và vận hành thông suốt cho toàn bộ tổ chức.",
          "Lên kế hoạch, tổ chức và vận hành các sự kiện công nghệ, hội thảo học thuật và cuộc thi lập trình của CLB.",
          "Xây dựng chiến dịch truyền thông đa kênh, sáng tạo nội dung và thiết kế ấn phẩm nhận diện thương hiệu cho CLB.",
        ],
        bio: "Quản trị nhân sự nội bộ, kết nối đối ngoại, bảo đảm hậu cần, tổ chức sự kiện và truyền thông đa kênh cho toàn bộ tổ chức (bao gồm Ban Event và Ban Marketing).",
        accentColor: "google.yellow",
      },
      {
        id: "gen7-technical",
        name: "Technical",
        role: "Technical Department",
        department: "Technical",
        avatar: gen7TechnicalThumb,
        photos: [gen7Technical, gen7Frontend, gen7Backend],
        subRoles: [
          "Ban Kỹ Thuật (Technical)",
          "Frontend Sub-Team",
          "Backend Sub-Team",
        ],
        description: [
          "Nghiên cứu công nghệ mới, xây dựng các sản phẩm phần mềm của CLB và tổ chức chuỗi workshop, tech talk học thuật bổ ích.",
          "Phát triển giao diện web, tối ưu trải nghiệm tương tác và hiệu năng ứng dụng cho các dự án của CLB.",
          "Xây dựng hệ thống backend, thiết kế API, cơ sở dữ liệu và triển khai hạ tầng trên nền tảng Google Cloud.",
        ],
        bio: "Nghiên cứu công nghệ mới, xây dựng các sản phẩm phần mềm của CLB và tổ chức chuỗi workshop, tech talk học thuật bổ ích (bao gồm Frontend và Backend).",
        accentColor: "google.green",
      },
    ],
  },
];
